module.exports = __webpack_public_path__ + "static/media/mchacks-martlet-tight.40b3cc48.svg";